/* Lily & Ruby — cart tier bar (10/15/20%) + complete-the-look add-on */
(function () {
  var tiers = [{ q: 2, p: 10 }, { q: 3, p: 15 }, { q: 4, p: 20 }];
  var SHOE = /(sandal|heel|mule|slingback|pump|stiletto|shoe|boot|loafer|flat)/i;

  function money(c) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(c, theme.settings.moneyFormat);
    } catch (e) {}
    return '$' + (c / 100).toFixed(2);
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function baseOf(t) { t = String(t || ''); var i = t.lastIndexOf(' - '); return (i > 0 ? t.slice(0, i) : t).toLowerCase().trim(); }
  function cents(v) { return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v; }

  function fillFor(count) {
    if (count <= 0) return 0;
    if (count < 2) return (count / 2) * 33.33;
    return Math.min(100, (count - 1) * 33.33);
  }

  function renderBar(count) {
    var next = null, cur = null, i;
    for (i = 0; i < tiers.length; i++) { if (count < tiers[i].q) { next = tiers[i]; break; } }
    for (i = tiers.length - 1; i >= 0; i--) { if (count >= tiers[i].q) { cur = tiers[i]; break; } }
    var msg;
    if (!next) msg = '<strong>20% off unlocked</strong> &middot; applied at checkout';
    else {
      var n = next.q - count;
      if (cur) msg = '<strong>' + cur.p + '% off unlocked</strong> &middot; add ' + n + ' more for ' + next.p + '% off';
      else msg = 'Add ' + n + ' more item' + (n > 1 ? 's' : '') + ' for <strong>' + next.p + '% off</strong>';
    }
    document.querySelectorAll('[data-lr-cartbar]').forEach(function (el) {
      var m = el.querySelector('.lr-cartbar__msg'), f = el.querySelector('.lr-cartbar__fill');
      if (m) m.innerHTML = msg;
      if (f) f.style.width = fillFor(count) + '%';
      el.querySelectorAll('[data-tier]').forEach(function (s) { s.classList.toggle('is-done', count >= parseInt(s.getAttribute('data-tier'), 10)); });
    });
  }

  // ---------- Complete the look ----------
  var cache = {};
  function getJSON(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { cache[url] = d.products || []; return cache[url]; })
      .catch(function () { return []; });
  }
  // Normalise /products.json (collection) and /recommendations JSON into one shape
  function norm(p) {
    var vars = (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available !== false, price: cents(v.price), compare: cents(v.compare_at_price || 0) }; });
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    var first = vars.filter(function (v) { return v.available; })[0] || vars[0] || {};
    return { id: p.id, title: p.title, url: p.url || ('/products/' + p.handle), img: img, vars: vars, price: first.price || cents(p.price), compare: first.compare || cents(p.compare_at_price || 0), available: vars.some(function (v) { return v.available; }) };
  }

  function pick(list, cart) {
    var ids = cart.items.map(function (i) { return i.product_id; });
    var bases = cart.items.map(function (i) { return baseOf(i.product_title); });
    for (var i = 0; i < list.length; i++) {
      var p = norm(list[i]);
      if (p.available && ids.indexOf(p.id) === -1 && bases.indexOf(baseOf(p.title)) === -1) return p;
    }
    return null;
  }

  function renderUpsell(cart) {
    var box = document.querySelector('[data-lr-upsell]');
    if (!box) return;
    if (!cart.items || !cart.items.length) { box.hidden = true; return; }
    var first = cart.items[0];
    var hasShoes = cart.items.some(function (i) { return SHOE.test(i.product_title); });
    var sources = [];
    if (!hasShoes) sources.push('/collections/shoes/products.json?limit=12');
    sources.push('/recommendations/products.json?product_id=' + first.product_id + '&limit=10&intent=complementary');
    sources.push('/recommendations/products.json?product_id=' + first.product_id + '&limit=10&intent=related');

    (function tryNext(k) {
      if (k >= sources.length) { box.hidden = true; return; }
      getJSON(sources[k]).then(function (list) {
        var p = pick(list, cart);
        if (!p) return tryNext(k + 1);
        draw(box, p);
      });
    })(0);
  }

  function draw(box, p) {
    var vars = p.vars.filter(function (v) { return v.available; });
    var img = p.img ? (p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
    var compare = p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '';
    var select = vars.length > 1
      ? '<select class="lr-up__select" aria-label="Size">' + vars.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
      : '<input type="hidden" class="lr-up__select" value="' + vars[0].id + '">';
    box.innerHTML =
      '<p class="lr-up__title">Complete the look</p>' +
      '<div class="lr-up__card">' +
        '<a href="' + p.url + '" class="lr-up__img">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="lr-up__info">' +
          '<a href="' + p.url + '" class="lr-up__name">' + esc(p.title) + '</a>' +
          '<span class="lr-up__price">' + money(p.price) + ' ' + compare + '</span>' +
          '<div class="lr-up__row">' + select + '<button type="button" class="lr-up__add">+ Add</button></div>' +
        '</div>' +
      '</div>';
    box.hidden = false;
    box.querySelector('.lr-up__add').addEventListener('click', function () {
      var btn = this, vid = box.querySelector('.lr-up__select').value;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: {} } }));
        })
        .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
    });
  }

  var pending;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderBar(c.item_count || 0); renderUpsell(c); })
        .catch(function () {});
    }, 150);
  }

  function isCartUrl(u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = of.apply(this, arguments);
      if (isCartUrl(url)) p.then(refresh, refresh);
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isCartUrl(url)) this.addEventListener('loadend', refresh);
    return oo.apply(this, arguments);
  };
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-drawer-open-cart, [href="/cart"]')) refresh();
  });
})();
